export default [

     {
          path: '/risk-mitigation-effort',
          name: 'RiskMitigationEffort',
          component: () => import("@/views/Page/RiskMitigationEffort/RiskMitigationEffort.vue"),
          meta: {
               title: 'Risk Mitigation Effort',
          },
     }
];